const zeroPad = (num: number, places: number) => {
  const numZeroes = places - num.toString().length + 1;
  if (numZeroes > 0) {
    return Array(+numZeroes).join('0') + num;
  }
  return num;
};

export default zeroPad;
